import { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useAppStoreDispatch, useAppStoreSelector } from '../../../store';
import { changeActiveCategory, selectIsGuestMode } from '../../portal/store';
import styles from './PortalGroupNav.module.scss';
import { useTranslation } from 'react-i18next';


function PortalGroupNav() {
  const { t } = useTranslation();
  const [groups, setGroups] = useState(['All']);
  const isGuest = useAppStoreSelector(selectIsGuestMode);
  const portalState = useAppStoreSelector((state) => state.portal);
  const categoryState = useAppStoreSelector((state) => state.category);
  const dispatch = useAppStoreDispatch();
  const categories = categoryState.data.categories;
  useEffect(() => {
    const categoriesList = ['All'];
    if (categories.length > 0) {
      categoriesList.push(...categoryState.data.categories);
    }
    if (isGuest) {
      categoriesList.push('Guest');
    }
    setGroups([...categoriesList]);
  }, [categories, isGuest, categoryState.data.categories]);

  const onActiveCategoryHandler = (event: React.SyntheticEvent, newValue: string) => {
    dispatch(changeActiveCategory({ newActiveCategory: newValue }));
  };
  
  return (
    <Box className={`ps ${styles['portal-group-nav-wrapper']}`}>
      <Tabs
        value={portalState.data.activeCategory}
        onChange={onActiveCategoryHandler}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="portal category tabs"
      >
        {groups.map((group, index) => (
          <Tab
            key={`category-group-${index}`}
            label={group === 'All' || group === 'Guest' ? t(`categories.${group}`) : group}
            value={group}
          />
        ))}
      </Tabs>
    </Box>
  );
}

export default PortalGroupNav;
